<template>
  <div class="table">
    <div class="table_info">
      <a @click="toDetail(item.id)" href="#">{{ item.number }}</a>
    </div>
    <div class="table_info">
      <a @click="toDetail(item.id)" href="#">《{{ item.name }}》</a>
    </div>
    <div class="table_info">
      <p>
        <!-- 引入element图片组件 -->
        <el-image :src="item.picture_url" :preview-src-list="item.picture_list"></el-image>
      </p>
    </div>
    <div class="table_info">{{ item.status_name }}</div>
  </div>
</template>

<script>
export default {
  name: "Item",
  data() {
    return {};
  },
  mounted() {},
  props: {
    // props接收父组件传递过来的数据
    item: {
      type: Object,
      default: function() {
        return []
      }
    }
  },
  methods: {
    toDetail(id) {
      // 点击列表，跳转到详情
      this.$router.push({
        path: `/detail/${id}`
      });
    },
    handleClose() {
      // 关闭图片事件
    }
  }
};
</script>

<style scoped>
.table_info a :hover {
  cursor: pointer;
}
/* 样式穿透 */
.table_info /deep/ .el-image {
  width: 0.32rem;
  height: auto;
  position: relative;
}
.table_info /deep/ .el-image-viewer__wrapper .el-image-viewer__close {
  top: 70px;
  right: 10px;
}
.table_info /deep/ .el-image-viewer__wrapper .el-image-viewer__actions {
  bottom: 60px;
}
</style>
